<div class="map-dialog">
  <div class="map-dialog-header" *ngIf="placa">
    <strong>{{ placa }}</strong>
  </div>

  <button
    type="button"
    class="map-dialog-address-trigger"
    *ngIf="!addressVisible"
    (click)="showAddress()"
    matTooltip="Clique para ver o endereço"
  >
    <mat-icon class="map-dialog-address-icon">place</mat-icon>
    <span>Clique para ver o endereço</span>
  </button>

  <div class="map-dialog-address" *ngIf="addressVisible">
    <mat-icon class="map-dialog-address-icon">place</mat-icon>
    <span *ngIf="loadingAddress">Carregando endereço...</span>
    <span *ngIf="!loadingAddress">{{ address }}</span>
  </div>

  <agm-map
    [ngStyle]="{ height: '360px' }"
    #AgmMap
    appDirectionsMap
    [mapTypeControl]="true"
    [zoomControl]="true"
    [fullscreenControl]="true"
    (mapReady)="mapReady($event)"
    [zoom]="3"
  >
  </agm-map>
</div>
